var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "clock-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4791",
    "data-name": "Rectangle 4791",
    width: 18,
    height: 18,
    transform: "translate(0 0)",
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons_Clock_Line",
    "data-name": "icons/Clock/Line",
    transform: "translate(2.623 2.623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M6.417,11.551A5.134,5.134,0,1,0,1.283,6.417,5.134,5.134,0,0,0,6.417,11.551Zm0,1.283A6.417,6.417,0,1,0,0,6.417,6.417,6.417,0,0,0,6.417,12.834Z",
    fill: "#6b6b95",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M.738,0a.713.713,0,0,1,.746.675v3.1L3.13,5.264a.631.631,0,0,1,0,.955.8.8,0,0,1-1.055,0L.21,4.531C.07,4.4.046,5.017-.008,4.053s0-3.377,0-3.377S.326,0,.738,0Z",
    transform: "translate(5.513 2.445)",
    fill: "#6b6b95"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallClockIcon);
export default __webpack_public_path__ + "static/media/smallClockIcon.1cfd86b33857739fbcd5f4e62e6d9c1e.svg";
export { ForwardRef as ReactComponent };